export default __webpack_public_path__ + "static/media/dumb_refacciones.85ac5926.jpg";